import { clsx } from 'clsx';

import { lastUsedTzid } from '#utils/dateUtils';

import type { PendingChangesFormType } from './usePendingChangesFormAdapter';

import styles from './PendingChangesModal.module.css';

interface CustomScheduleProps {
  form: PendingChangesFormType;
  className?: string;
  defaultDate?: Date;
}

export function CustomSchedule({ form, className, defaultDate: date }: CustomScheduleProps) {
  const executionDate = form.getFieldValue('executionDate');
  const defaultDate = executionDate ? new Date(executionDate) : date;
  const today = new Date();
  const defaultTzid = lastUsedTzid();

  return (
    <form.AppField name="executionDate">
      {(field) => (
        <field.DateTimePicker
          className={clsx(styles.customSchedule, className)}
          timezoneProps={{ tzid: defaultTzid }}
          datepickerProps={{ minDate: today.getTime(), defaultDate: defaultDate?.getTime() }}
        />
      )}
    </form.AppField>
  );
}
